// Sistema simples de event emitter para atualizar os dados das estações (INMET)

const listeners = new Set();

export const onInmetUpdate = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback); // retorna função para remover listener
};

export const emitInmetUpdate = () => {
  listeners.forEach(callback => callback());
};
